<template>
    
</template>
<script>
export default {
    created(){
        window.location.href = "https://help.integrateiq.com/en/collections/2512978-message-iq";
    }
}
</script>